"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.BannerOversized = void 0;
require("./BannerOversized.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _ActionGroupDefault = _interopRequireDefault(require("../ActionGroupDefault/ActionGroupDefault"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _LoaderGhostCard = _interopRequireDefault(require("../LoaderGhostCard/LoaderGhostCard"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * BannerOversized component
 *
 * @method
 * @param { BannerOversizedProps } props
 * @returns BannerOversized
 */

const BannerOversized = props => {
  const {
    actionGroups,
    backgroundColor,
    bannerImage,
    body,
    borderColor = defaultProps.borderColor,
    cornerRadius = defaultProps.cornerRadius,
    elevation = defaultProps.elevation,
    externalImageElement,
    externalActionElement,
    externalFullyClickableActionElement,
    fullyClickableParent,
    iconName,
    isLoading = defaultProps.isLoading,
    loaderHeightLg,
    loaderHeightMd,
    loaderHeightSm,
    loaderHeightXl,
    textColor = defaultProps.textColor,
    imagePosition = defaultProps.imagePosition
  } = props;
  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-BannerOversized"
    }, /*#__PURE__*/_react.default.createElement(_LoaderGhostCard.default, {
      className: "pal-c-BannerOversized__Loader",
      style: {
        '--pal-loaderghost-card-height-sm': loaderHeightSm,
        '--pal-loaderghost-card-height-md': loaderHeightMd,
        '--pal-loaderghost-card-height-lg': loaderHeightLg,
        '--pal-loaderghost-card-height-xl': loaderHeightXl
      }
    }));
  }
  let formattedActionFullyClick;
  const hasImage = bannerImage || externalImageElement;
  const renderActions = actionGroups || externalActionElement;
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  const isKnockoutLink = textColor === 'content-knockout';
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: actionGroups?.actions[0],
      types: actionGroups?.types,
      hasOneAction: hasOneAction,
      derivedAriaLabel: actionGroups?.actions[0].label,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-BannerOversized', {
    'pal-c-BannerOversized--backgroundColor': backgroundColor,
    [`pal-c-BannerOversized__imagePosition--${imagePosition}`]: imagePosition,
    'pal-c-BannerOversized__corners--rounded': cornerRadius,
    'pal-c-BannerOversized--withImage': hasImage,
    'pal-c-BannerOversized--withIcon': !!iconName,
    [`pal-c-BannerOversized__elevation--${elevation}`]: elevation,
    'pal-c-BannerOversized--borderColor': borderColor,
    'pal-c-BannerOversized--oneAction': hasOneAction
  });
  const renderBannerHeaderImage = () => {
    if (externalImageElement) {
      return (0, _renderObject.renderObject)(externalImageElement);
    } else {
      return /*#__PURE__*/_react.default.createElement(_Image.default, bannerImage);
    }
  };
  const renderBannerFooterAction = () => {
    if (externalActionElement) {
      return (0, _renderObject.renderObject)(externalActionElement);
    } else {
      return /*#__PURE__*/_react.default.createElement(_ActionGroupDefault.default, _extends({
        action1: actionGroups.actions[0],
        action2: actionGroups.actions[1],
        isKnockoutLink: isKnockoutLink
      }, actionGroups));
    }
  };
  const containerStyle = {
    ...(borderColor && {
      '--borderColor': `var( --pal-colors-default-${borderColor} )`
    }),
    ...(backgroundColor && {
      '--backgroundColor': `var( --pal-colors-default-${backgroundColor} )`
    }),
    ...(cornerRadius && {
      '--cornerRadius': `var( --pal-${cornerRadius} )`
    })
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: containerStyle
  }, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalFullyClickableActionElement && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalFullyClickableActionElement))), hasImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerOversized__image"
  }, renderBannerHeaderImage()), iconName && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerOversized__icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    size: "xxl"
  })), (body || renderActions) && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerOversized__content"
  }, body && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerOversized__body"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "displayBody",
    textAlign: "center",
    textColor: textColor
  }, body)), renderActions && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerOversized__actions"
  }, renderBannerFooterAction())));
};

/**
 * Property type definitions
 * @typedef BannerOversizedProps
 * @type {object}
 * @property {object} actionGroups - Allows passing an object to the actionGroup prop.
 * @property {string} backgroundColor - Sets the background color for the banner.
 * @property {object} bannerImage - Allows passing image object to render Palette Image component for the banner.
 * @property {string} body - Sets the body text for the banner.
 * @property {string} borderColor - Sets the border color for the banner.
 * @property {string} cornerRadius - Sets the border radius of the banner container.
 * @property {string} elevation - Sets the elevation for the banner.
 * @property {object} externalActionElement - Accepts actions to render from web-site with business logic.
 * @property {object} externalImageElement - Accepts UltaAsset to render the image for the banner.
 * @property {object} externalFullyClickableActionElement - Accepts fully clickable absolute action from web-site.
 * @property {boolean} fullyClickableParent - Set to true if card can be fully clickable.
 * @property {string} iconName - Sets the icon name for the banner.
 * @property {boolean} isLoading - To show the loading state of the component.
 * @property {string} loaderHeightLg - The height of the loader on LG inflections (ex - "11rem")
 * @property {string} loaderHeightMd - The height of the loader on MD inflections (ex - "11rem")
 * @property {string} loaderHeightSm - The height of the loader on SM inflections (ex - "11rem")
 * @property {string} loaderHeightXl - The height of the loader on XL inflections (ex - "11rem")
 * @property {string} textColor - Sets the text color for the banner.
 * @property {string} imagePosition - Sets the image position for the banner.
 */
exports.BannerOversized = BannerOversized;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an object to the actionGroup prop
   */
  actionGroups: _propTypes.default.object,
  /**
   * Sets the background color for the banner
   */
  backgroundColor: _propTypes.default.string,
  /**
   * Allows passing image object to render Palette Image component for the banner
   */
  bannerImage: _propTypes.default.object,
  /**
   * Sets the body text for the banner
   */
  body: _propTypes.default.string,
  /**
   * Sets the border color for the banner
   */
  borderColor: _propTypes.default.string,
  /**
   * Sets the border radius of the banner
   */
  cornerRadius: _propTypes.default.string,
  /**
   * Sets the elevation for the banner
   */
  elevation: _propTypes.default.oneOf(['low', 'medium', 'high']),
  /**
   * Accepts actions to render from web-site with business logic.
   */
  externalActionElement: _propTypes.default.object,
  /**
   * Accepts UltaAsset to render the image for the banner.
   */
  externalImageElement: _propTypes.default.object,
  /**
   * Accepts fully clickable absolute action from web-site.
   */
  externalFullyClickableActionElement: _propTypes.default.object,
  /**
   * Set to true if card can be fully clickable.
   */
  fullyClickableParent: _propTypes.default.bool,
  /**
   * Sets the icon name for the banner */
  iconName: _propTypes.default.string,
  /**
   * To show the loading state of the component.
   */
  isLoading: _propTypes.default.bool,
  /**
   * The height of the loader on LG inflections (ex - "11rem")
   */
  loaderHeightLg: _propTypes.default.string,
  /**
   * The height of the loader on MD inflections (ex - "11rem")
   */
  loaderHeightMd: _propTypes.default.string,
  /**
   * The height of the loader on SM inflections (ex - "11rem")
   */
  loaderHeightSm: _propTypes.default.string,
  /**
   * The height of the loader on XL inflections (ex - "11rem")
   */
  loaderHeightXl: _propTypes.default.string,
  /**
   * Sets the text color for the banner
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * Sets the image position for the banner
   */
  imagePosition: _propTypes.default.oneOf(['top', 'left'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} borderColor=undefined - Set default borderColor of the banner to undefined
 * @property {string} elevation=undefined - Set default elevation of the banner to undefined
 * @property {string} cornerRadius=undefined - Set default cornerRadius to undefined
 * @property {string} imagePosition='top' - Set default imagePosition of the banner to top
 * @property {string} textColor='content-default' - Set default textColor of the banner to content-default
 * @property {boolean} isLoading=false - Set default isLoading to false
 */
const defaultProps = exports.defaultProps = {
  borderColor: undefined,
  cornerRadius: undefined,
  elevation: undefined,
  imagePosition: 'top',
  textColor: 'content-default',
  isLoading: false
};
BannerOversized.propTypes = propTypes;
var _default = exports.default = BannerOversized;